import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetLastOperation = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_ID_REPORT_GAMES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetLastOperationAction({
                    data: data.data,
                    count: data.count,
                    allPage: data.allPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetLastOperation as SetGetLastOperation
}